/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MoneyCurrencyRubleRectIcon16Light } from './MoneyCurrencyRubleRectIcon16Light';
import { MoneyCurrencyRubleRectIcon16Regular } from './MoneyCurrencyRubleRectIcon16Regular';
import { MoneyCurrencyRubleRectIcon16Solid } from './MoneyCurrencyRubleRectIcon16Solid';
import { MoneyCurrencyRubleRectIcon20Light } from './MoneyCurrencyRubleRectIcon20Light';
import { MoneyCurrencyRubleRectIcon20Regular } from './MoneyCurrencyRubleRectIcon20Regular';
import { MoneyCurrencyRubleRectIcon20Solid } from './MoneyCurrencyRubleRectIcon20Solid';
import { MoneyCurrencyRubleRectIcon24Regular } from './MoneyCurrencyRubleRectIcon24Regular';
import { MoneyCurrencyRubleRectIcon24Solid } from './MoneyCurrencyRubleRectIcon24Solid';
import { MoneyCurrencyRubleRectIcon32Regular } from './MoneyCurrencyRubleRectIcon32Regular';
import { MoneyCurrencyRubleRectIcon64Regular } from './MoneyCurrencyRubleRectIcon64Regular';
var sizes = {
    16: {
        light: MoneyCurrencyRubleRectIcon16Light,
        regular: MoneyCurrencyRubleRectIcon16Regular,
        solid: MoneyCurrencyRubleRectIcon16Solid,
    },
    20: {
        light: MoneyCurrencyRubleRectIcon20Light,
        regular: MoneyCurrencyRubleRectIcon20Regular,
        solid: MoneyCurrencyRubleRectIcon20Solid,
    },
    24: {
        regular: MoneyCurrencyRubleRectIcon24Regular,
        solid: MoneyCurrencyRubleRectIcon24Solid,
    },
    32: {
        regular: MoneyCurrencyRubleRectIcon32Regular,
    },
    64: {
        regular: MoneyCurrencyRubleRectIcon64Regular,
    },
};
export var MoneyCurrencyRubleRectIcon = forwardRef('MoneyCurrencyRubleRectIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
